/**
 * Loads Application / Application Notes from the YMM catalog API.
 *
 * 1) When the URL includes catalog params (ymm_year, ymm_make, ymm_model, …), uses those.
 * 2) Otherwise loads a default vehicle from the compatibility API
 *    (?type=ajax&request=compatibility&product=<Shopify product id>) — same source as the
 *    Compatibility tab — then runs the same catalog lookup. Per-vehicle strings are not
 *    available from SKU/variant id alone without some YMM context.
 *
 * Snippet may set window.__ymmPdpPrefetchPromise (page 1) before this file loads.
 */
(function () {
  var ymmPdpFetchDone = false;

  function showRow(row, value, valueCellSelector) {
    if (!row || value == null || value === '') return;
    var str = String(value).trim();
    if (!str) return;
    var cell = row.querySelector(valueCellSelector);
    if (!cell) return;
    cell.textContent = str;
    row.removeAttribute('hidden');
    row.style.display = '';
  }

  function applyMatch(container, match) {
    if (!match) return;
    var appRow = container.querySelector('.ymm-pdp-application-row');
    var notesRow = container.querySelector('.ymm-pdp-application-notes-row');
    var addNotesRow = container.querySelector('.ymm-pdp-additional-notes-row');
    var posRow = container.querySelector('.ymm-pdp-position-row');
    if (match.application) {
      showRow(appRow, match.application, '.ymm-pdp-application-value');
    }
    if (match.application_notes) {
      showRow(notesRow, match.application_notes, '.ymm-pdp-application-notes-value');
    }
    if (match.additional_notes) {
      showRow(addNotesRow, match.additional_notes, '.ymm-pdp-additional-notes-value');
    }
    if (match.position) {
      showRow(posRow, match.position, '.ymm-pdp-position-value');
    }
  }

  function findMatchingProduct(products, productId, ymmId) {
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (ymmId && String(p.ymm_id) === String(ymmId)) return p;
      if (String(p.product_id) === String(productId)) return p;
    }
    return null;
  }

  async function fetchYmmProductForPdp(baseUrl, queryParams, productId, ymmId) {
    var page = 1;
    var totalPages = 1;
    var maxPages = 25;
    var prefetchFirstPage = null;
    var prefetchPromise = window.__ymmPdpPrefetchPromise;

    if (prefetchPromise) {
      try {
        delete window.__ymmPdpPrefetchPromise;
        var d = await prefetchPromise;
        if (d && Array.isArray(d.products)) prefetchFirstPage = d;
      } catch (e) {
        prefetchFirstPage = null;
      }
    }

    do {
      var data;
      if (prefetchFirstPage && page === 1) {
        data = prefetchFirstPage;
        prefetchFirstPage = null;
      } else {
        queryParams.page_no = String(page);
        var url = baseUrl + '?' + new URLSearchParams(queryParams).toString();
        var res = await fetch(url);
        if (!res.ok) return null;
        data = await res.json();
      }
      totalPages = parseInt(data.total_pages, 10) || 1;
      var products = data.products || [];
      var match = findMatchingProduct(products, productId, ymmId);
      if (match) return match;
      page++;
    } while (page <= totalPages && page <= maxPages);

    return null;
  }

  function resolveYmmIdFromUrl(params, variantIdAttr) {
    var urlId = params.get('id');
    var variantParam = params.get('variant');
    if (!urlId) return null;
    if (variantIdAttr && String(urlId) === String(variantIdAttr)) return null;
    if (variantParam && String(urlId) === String(variantParam)) return null;
    return urlId;
  }

  function buildCatalogQueryParams(ymmYear, ymmMake, ymmModel, ymmEngine, ymmPartType, sortBy) {
    var queryParams = {
      type: 'ajax',
      ymm_part: 'parts',
      ymm_year: ymmYear,
      ymm_make: ymmMake,
      ymm_model: ymmModel,
      page_no: '1',
      page_limit: '50',
      sort_by: sortBy || 'best-selling',
      dataType: 'json',
    };
    if (ymmEngine) queryParams.ymm_engine = ymmEngine;
    if (ymmPartType) queryParams.ymm_part_type = ymmPartType;
    return queryParams;
  }

  async function fetchCompatibilityFirstRow(baseUrl, productId) {
    var url =
      baseUrl +
      '?' +
      new URLSearchParams({
        type: 'ajax',
        request: 'compatibility',
        product: String(productId),
        page: '1',
        limit: '10',
        dataType: 'json',
      }).toString();
    var res = await fetch(url);
    if (!res.ok) return null;
    var data = await res.json();
    if (!Array.isArray(data) || !data.length) return null;
    return data[0];
  }

  function initYmmApplication() {
    var container = document.getElementById('product-ymm-info-table');
    if (!container) return;

    var productId = container.getAttribute('data-product-id');
    var baseUrl = container.getAttribute('data-ymm-api-base');
    var variantIdAttr = container.getAttribute('data-variant-id');
    var partTypeFallback = container.getAttribute('data-ymm-part-type');
    if (!productId || !baseUrl) return;

    if (ymmPdpFetchDone) return;

    var params = new URLSearchParams(window.location.search);
    var ymmYear = params.get('ymm_year');
    var ymmMake = params.get('ymm_make');
    var ymmModel = params.get('ymm_model');

    if (ymmYear && ymmMake && ymmModel) {
      ymmPdpFetchDone = true;

      var ymmId = resolveYmmIdFromUrl(params, variantIdAttr);
      var ymmEngine = params.get('ymm_engine');
      var ymmPartType = params.get('ymm_part_type');
      var queryParams = buildCatalogQueryParams(
        ymmYear,
        ymmMake,
        ymmModel,
        ymmEngine,
        ymmPartType,
        params.get('sort_by')
      );

      fetchYmmProductForPdp(baseUrl, queryParams, productId, ymmId)
        .then(function (match) {
          applyMatch(container, match);
        })
        .catch(function () {});

      return;
    }

    ymmPdpFetchDone = true;

    fetchCompatibilityFirstRow(baseUrl, productId)
      .then(function (row) {
        if (!row) return;
        var pt = row.value_name || partTypeFallback;
        var queryParams = buildCatalogQueryParams(
          row.value_name4,
          row.value_name3,
          row.value_name2,
          row.value_name1,
          pt,
          params.get('sort_by')
        );
        return fetchYmmProductForPdp(baseUrl, queryParams, productId, null);
      })
      .then(function (match) {
        applyMatch(container, match);
      })
      .catch(function () {});
  }

  window.initYmmPdpApplication = initYmmApplication;

  initYmmApplication();
})();
